module.exports = ({
    "CDMS804TT001": "ดำเนินการ ECS",
    "CDMS804TT002": "ประวัติการแก้ไขของ {subject_id}",
    "CDMS804H001": "No.",
    "CDMS804H002": "สถานวิจัย",
    "CDMS804H003": "รหัสผู้เข้าร่วมวิจัย",
    "CDMS804H004": "ผลการดำเนินการ ECS",
    "CDMS804H005": "ผู้ดำเนินการ ECS",
    "CDMS804H006": "วันที่เริ่มต้น ECS",
    "CDMS804H007": "วันที่สิ้นสุด ECS",
    "CDMS804LB001": "จำนวนผู้เข้าร่วมวิจัยทั้งหมด",
    "CDMS804LB002": "จำนวนผู้เข้าร่วมวิจัยที่ไม่สำเร็จทั้งหมด",
    "CDMS804LB003": "จำนวนผู้เข้าร่วมวิจัยที่อยู่ระหว่างดำเนินการศึกษาทั้งหมด",
    "CDMS804BTN001": "ดำเนินการ ECS",
    "CDMS804OPT001": "สำเร็จ",
    "CDMS804OPT002": "อยู่ระหว่างดำเนินการ",
    "CDMS804OPT003": "ไม่สำเร็จ",
    "CDMS804OPT004": "ว่าง",
    "CDMS804OPT005": "เลือกทั้งหมด",
    "CDMS804MSG001": "การดำเนินการ ECS เสร็จสิ้นแล้ว<br/>มีเข้าร่วมวิจัยจำนวน {x} รายที่ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    "CDMS804MSG002": "คุณแน่ใจหรือไม่ว่าต้องการใช้ ECS อีกครั้ง?",
    "CDMS400MSG007": "ไม่สามารถเรียกใช้ ECS ได้เนื่องจากมีหัวข้อที่ถูกปิดใช้งาน"
});
